import { ReactElement, ReactNode } from 'react';
import { NOT_REAL_SPORTS } from 'utils/constants/sportsbook/sportsbook-data-hierarchy';
import { TimeFilter } from 'components/Shared/TimeFilter';
import { TimeFilterSkeleton } from 'components/Shared/TimeFilter/Skeleton';

type TProps = {
  title: ReactNode;
  isLoading?: boolean;
  sport?: string;
  showSortButton?: boolean;
};

export const TimeFilterWrapper = ({
  title,
  isLoading,
  sport,
  showSortButton
}: TProps): ReactElement => {
  return (
    <div className="sportsHeaderWrapper">
      {isLoading ? (
        <TimeFilterSkeleton
          showTimeFilter={!!(sport && !NOT_REAL_SPORTS.includes(sport))}
        />
      ) : (
        <TimeFilter title={title} showSortButton={showSortButton} />
      )}
    </div>
  );
};
